// extracted by mini-css-extract-plugin
module.exports = {"container":"Newhtml_container__erRD5","head":"Newhtml_head__3zh14","textuser":"Newhtml_textuser__8Obhp","body":"Newhtml_body__34Kkv","card":"Newhtml_card__l-oRJ"};